import React from "react";
import { CharacterSheet, Vantagem, Desvantagem } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const VantagensDesvantagens: React.FC<Props> = ({ character, onChange }) => {
  const addVantagem = () => {
    onChange({
      ...character,
      vantagens: [...character.vantagens, { nome: "", nivel: 1, custo: 0 }],
    });
  };

  const removeVantagem = (index: number) => {
    onChange({
      ...character,
      vantagens: character.vantagens.filter((_, i) => i !== index),
    });
  };

  const updateVantagem = (index: number, field: keyof Vantagem, value: any) => {
    const newVantagens = [...character.vantagens];
    newVantagens[index] = { ...newVantagens[index], [field]: value };
    onChange({ ...character, vantagens: newVantagens });
  };

  const addDesvantagem = () => {
    onChange({
      ...character,
      desvantagens: [...character.desvantagens, { nome: "", nivel: 1, ganho: 0 }],
    });
  };

  const removeDesvantagem = (index: number) => {
    onChange({
      ...character,
      desvantagens: character.desvantagens.filter((_, i) => i !== index),
    });
  };

  const updateDesvantagem = (index: number, field: keyof Desvantagem, value: any) => {
    const newDesvantagens = [...character.desvantagens];
    newDesvantagens[index] = { ...newDesvantagens[index], [field]: value };
    onChange({ ...character, desvantagens: newDesvantagens });
  };

  return (
    <div className="section">
      <h2>Vantagens e Desvantagens</h2>
      <div className="vantagens-grid">
        <div>
          <h3>Vantagens</h3>
          <button type="button" onClick={addVantagem} className="btn-add">
            + Adicionar Vantagem
          </button>
          {character.vantagens.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>Vantagem</th>
                  <th>Nível</th>
                  <th>Custo</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {character.vantagens.map((vantagem, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={vantagem.nome}
                        onChange={(e) => updateVantagem(index, "nome", e.target.value)}
                        placeholder="Nome da vantagem"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={vantagem.nivel}
                        onChange={(e) => updateVantagem(index, "nivel", parseInt(e.target.value) || 1)}
                        min="1"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={vantagem.custo}
                        onChange={(e) => updateVantagem(index, "custo", parseInt(e.target.value) || 0)}
                        min="0"
                      />
                    </td>
                    <td>
                      <button type="button" onClick={() => removeVantagem(index)} className="btn-remove">
                        Remover
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div>
          <h3>Desvantagens</h3>
          <button type="button" onClick={addDesvantagem} className="btn-add">
            + Adicionar Desvantagem
          </button>
          {character.desvantagens.length > 0 && (
            <table>
              <thead>
                <tr>
                  <th>Desvantagem</th>
                  <th>Nível</th>
                  <th>Ganho</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {character.desvantagens.map((desvantagem, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={desvantagem.nome}
                        onChange={(e) => updateDesvantagem(index, "nome", e.target.value)}
                        placeholder="Nome da desvantagem"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={desvantagem.nivel}
                        onChange={(e) => updateDesvantagem(index, "nivel", parseInt(e.target.value) || 1)}
                        min="1"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        value={desvantagem.ganho}
                        onChange={(e) => updateDesvantagem(index, "ganho", parseInt(e.target.value) || 0)}
                        min="0"
                      />
                    </td>
                    <td>
                      <button type="button" onClick={() => removeDesvantagem(index)} className="btn-remove">
                        Remover
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};
